<h3 mat-dialog-title>
  {{ data.title }}
  <mat-icon class="float-end" (click)="close()" [mat-dialog-close]="true">close</mat-icon>
</h3>
<mat-dialog-content class="mat-typography">
  <div *ngIf="data.hasTable" class="table__container">
    <dx-data-grid
      #dataGridRef
      class="gah-datagrid"
      [dataSource]="data.rowData"
      [remoteOperations]="true"
      [showColumnLines]="true"
      [showRowLines]="true"
      [showBorders]="true"
      [focusedRowEnabled]="false"
      [columnMinWidth]="100"
      [wordWrapEnabled]="true"
    >
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-scrolling
        [preloadEnabled]="true"
        rowRenderingMode="standard"
        [useNative]="true"
      ></dxo-scrolling>

      <dxi-column
        [caption]="'territory-label' | translate"
        dataField="territoryName"
        [allowFiltering]="true"
        [allowSorting]="true"
        minWidth="100"
      >
      </dxi-column>

      <dxi-column
        [caption]="'release-date-label' | translate"
        dataField="formattedReleaseDate"
        [calculateCellValue]="calculateReleaseDate"
        [allowFiltering]="true"
        [allowSorting]="true"
        minWidth="100"
      >
      </dxi-column>

      <!--  START 02-04-2024, GAHR-1502 added below method -->
      <dxi-column
        [caption]="'status-label' | translate"
        dataField="status"
        [allowFiltering]="true"
        [allowSorting]="true"
        minWidth="100"
      >
      </dxi-column>
      
      <dxo-paging [pageSize]="25"> </dxo-paging>
      <dxo-pager
        [visible]="true"
        [allowedPageSizes]="[5, 10, 25, 50, 100, 'all']"
        [displayMode]="'compact'"
        [showPageSizeSelector]="true"
        [showInfo]="true"
        infoText="Displaying {0} - {1} of {2} "
        [showNavigationButtons]="true"
      >
      </dxo-pager>
    </dx-data-grid>
  </div>
</mat-dialog-content>
